import { render, staticRenderFns } from "./duty.vue?vue&type=template&id=6fded9e5&scoped=true&"
import script from "./duty.vue?vue&type=script&lang=js&"
export * from "./duty.vue?vue&type=script&lang=js&"
import style0 from "./duty.vue?vue&type=style&index=0&id=6fded9e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fded9e5",
  null
  
)

export default component.exports